import React from 'react';
import styled from 'styled-components';

import { useScreenQuery } from 'playup-web-core';

import Visa from './visa.svg';
import Mastercard from './mastercard.svg';

const FinancialProviders = () => {
	const { isSmall } = useScreenQuery();

	return (
		<SectionContainer>
			<Title isSmallScreen={isSmall}>Trusted by</Title>
			<ProviderImageGroup>
				<ProviderImage isSmallScreen={isSmall} src={Visa} alt={'Visa'} />
				<ProviderImage isSmallScreen={isSmall} src={Mastercard} alt={'Mastercard'} />
			</ProviderImageGroup>
		</SectionContainer>
	);
};

export default FinancialProviders;

const SectionContainer = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	marginTop: '30px',
	borderTop: '1px solid',
	borderTopColor: theme.colors.lightGreyR,
	width: '90%',
}));

const Title = styled.p<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	textTransform: 'uppercase',
	fontSize: isSmallScreen ? '14px' : '18px',
	margin: '20px 0',
	color: theme.colors.white,
	fontWeight: 600,
}));

const ProviderImageGroup = styled.div({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	alignItems: 'center',
	justifyContent: 'center',
});

const ProviderImage = styled.img<{ isSmallScreen: boolean; isWhiteColor?: boolean }>(
	({ isSmallScreen, isWhiteColor }) => ({
		height: isSmallScreen ? '36px' : '48px',
		margin: '0 5px',
		filter: isWhiteColor ? 'invert(100%)' : 'none',
	})
);
